module.exports = __webpack_public_path__ + "static/media/StrengthMagazineSpread5.6c1f7aa3.jpg";